import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import VueScreen from 'vue-screen';
import Icsilab from './config'
require('./components/composants/imports.js');

Vue.config.productionTip = false

import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";
import VueCookieAcceptDecline from "vue-cookie-accept-decline";
Vue.component("vue-cookie-accept-decline", VueCookieAcceptDecline);

Vue.use(VueScreen, 'bootstrap');
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(Vuetify);

Vue.use(Icsilab)
const store = Icsilab.store
const router = Icsilab.router

new Vue({
  render: h => h(App),
  vuetify: new Vuetify(Icsilab.optionVuetify),
  router,
  store
}).$mount('#app')
